const root = {
  setApplication(applicationName) {
    window.localStorage.setItem('application', applicationName)
  },

  getApplication() {
    return window.localStorage.getItem('application')
  },
}

const organization = {
  setOrganizationStructure(data) {
    window.localStorage.setItem('orgStructure', JSON.stringify(data))
  },

  getOrganizationStructure() {
    return JSON.parse(window.localStorage.getItem('orgStructure'))
  },

  setOrganization(data) {
    window.localStorage.setItem('organization', JSON.stringify(data))
  },

  getOrganization() {
    return JSON.parse(window.localStorage.getItem('organization'))
  },

  setCountryCodes(data) {
    window.localStorage.setItem('countryCodes', JSON.stringify(data))
  },

  getCountyCodes() {
    return JSON.parse(window.localStorage.getItem('countryCodes'))
  },

  setOrganizationCategories(data) {
    window.localStorage.setItem('organizationCategories', JSON.stringify(data))
  },

  getOrganizationCategories() {
    return JSON.parse(window.localStorage.getItem('organizationCategories'))
  },
}

const accounts = {
  setAccounts(data) {
    window.localStorage.setItem('accounts', JSON.stringify(data))
  },

  getAccounts() {
    return JSON.parse(window.localStorage.getItem('accounts'))
  },
}

const access = {
  setToken(token) {
    window.localStorage.setItem('token', token)
  },

  getToken() {
    return window.localStorage.getItem('token')
  },

  setOrganizationId(organizationId) {
    window.localStorage.setItem('organizationId', organizationId)
  },

  getOrganizationId() {
    return window.localStorage.getItem('organizationId')
  },

  setUserId(userId) {
    window.localStorage.setItem('userId', userId)
  },

  getUserId() {
    return window.localStorage.getItem('userId')
  },

  setAccount(account) {
    window.localStorage.setItem('account', JSON.stringify(account))
  },

  getAccount() {
    return JSON.parse(window.localStorage.getItem('account'))
  },

  setSession(data) {
    this.setToken(data.accessToken)
    organization.setOrganization(data.account.organization)
    this.setOrganizationId(data.account.organization._id)
    this.setUserId(data.userId)
    this.setAccount(data.account)
  },

  logout() {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('organizationId')
    window.localStorage.removeItem('userId')
    window.localStorage.removeItem('account')
  },

  isLoggedIn() {
    return (
      Boolean(this.getToken()) &&
      Boolean(this.getOrganizationId()) &&
      Boolean(this.getUserId())
    )
  },
}

export default {
  access,
  organization,
  accounts,
  ...root,
}
